/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adresseSuggestionSchema } from "../adresseSuggestionSchema.ts";
import { z } from "zod";

export const suggestAdressesQueryParamsSchema = z.object({
      "search": z.string().min(3).max(200).describe("Début d'adresse saisi (numéro, voie, commune…).")
      })

/**
 * @description La liste des suggestions est retournée (vide si aucune ou si le géocodeur est indisponible).
 */
export const suggestAdresses200Schema = z.array(z.lazy(() => adresseSuggestionSchema).describe("Adresse proposée par le géocodeur de la Base Adresse Nationale."))

export const suggestAdressesQueryResponseSchema = z.lazy(() => suggestAdresses200Schema)